define(["jquery"], function ($) {
    vidscoremodlightclose = {
        Init: function () {
            $(document).on('keyup', function (evt) {
                if (evt.keyCode === 27) {
                    $('.yt_player_iframe').each(function () {
                        vidscoremodlightclose.CloseYouTubeScoreLightBox(this.id);
                    });
                }
            });
        },
        CloseYouTubeScoreLightBox: function (videoid) {
            $("#" + videoid).attr("src", $("#" + videoid).attr("src").replace("autoplay=1", "autoplay=0"));
        },

        OpenYouTubeScoreLightBox: function (videoid, autoplay) {
            if(autoplay===1)
            $("#" + videoid).attr("src", $("#" + videoid).attr("src").replace("autoplay=0", "autoplay=" + autoplay));

        }
    }

        return vidscoremodlightclose;
    });
